<template>
    <div>
      <div class="w-full mb-3" v-if="!vehicleAddEdit && !vehicleBook">
        <div class="text-left">
          <vs-select autocomplete v-validate="''" label="Select Office" name="filter_office_id" v-model="filter_office_id" @change="vehiclebooked()">
              <vs-select-item value="all" text="All" />
              <vs-select-item :key="index" :value="item.id" :text="item.office_name" v-for="(item,index) in offices" />
          </vs-select>
        </div>
        <div class="text-right">
          <vs-button
            class="mr-2 mt-2 m-auto gradient-btn"
            @click.prevent="vehicleBook = true"
          >Book Vehicle</vs-button>
        </div>
      </div>
      <form class="w-full" v-if="vehicleBook" autocomplete="off" data-vv-scope="book-form">
        <!-- <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">Book Vehicle</h4>
        </div> -->
        <div class="vx-row">
          <!-- <div class="vx-col md:w-1/1 form-group w-full">
          <div class="vx-row">-->

          <!-- <div class="vx-col md:w-1/4 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Office"
              name="office_id"
              v-model="office_id"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item,index) in offices"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('book-form.office_id') }}</span>
          </div>-->

          <!-- </div>
          </div>-->
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Office"
              name="office_id"
              v-model="office_id"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item,index) in offices"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('book-form.office_id') }}</span>
          </div>

          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">Start Date</label>
            <flat-pickr
              :config="configFromdateTimePicker"
              @on-change="onFromChange"
              class="vs-inputx vs-input--input normal time"
              label="Start Date"
              v-validate="'required'"
              name="from_date"
              v-model="from_date"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.from_date') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">Start Time</label>
            <flat-pickr
              :config="configdateTimePicker"
              class="vs-inputx vs-input--input normal time"
              v-validate="'required'"
              v-model="start_time"
              autocomplete="off"
              name="start_time"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.start_time') }}</span>
          </div>

          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">End Date</label>
            <flat-pickr
              :config="configTodateTimePicker"
              class="vs-inputx vs-input--input normal time"
              label="End Date"
              v-validate="'required'"
              name="end_date"
              v-model="end_date"
              autocomplete="off"
              @on-change="onToChange"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.end_date') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <label for class="vs-input--label">End Time</label>
            <flat-pickr
              :config="configdateTimePicker"
              class="vs-inputx vs-input--input normal time"
              v-validate="'required'"
              v-model="end_time"
              autocomplete="off"
              name="end_time"
            />
            <span class="text-danger text-sm">{{ errors.first('book-form.end_time') }}</span>
          </div>
        </div>
        <div class="vx-row mb-5 mt-5">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto gradient-btn"
              @click.prevent="searchVehicle()"
              :disabled="button_loading"
              id="vehicle-addupdate"
            >Search</vs-button>
            <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelBook()">Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5" v-show="availableVehicle.length != 0">
        <vs-table
          :data="availableVehicle"
          pagination
          max-items="10"          
        >
          <template slot="thead">
            <vs-th>Plate #</vs-th>
            <vs-th>Make - Model</vs-th>
            <vs-th>Type</vs-th>
            <vs-th>Year</vs-th>
            <vs-th>Colour</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.number }}</vs-td>
              <vs-td>{{ tr.name+" - "+tr.brand }}</vs-td>
              <vs-td>{{ tr.type }}</vs-td>
              <vs-td>{{ tr.year }}</vs-td>
              <vs-td>{{ tr.colour }}</vs-td>
              <vs-td>
                <vs-button
                  color="danger"
                  type="filled"
                  size="small"
                  title="Book Vehicle"
                  @click.prevent="confirmBook(data[indextr].id)"
                >Book</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div class="tab-text" v-if="!vehicleBook">
        <div class="mt-5 mb-5">
          <vs-table :data="booked" pagination max-items="15">
            <template slot="thead">
              <vs-th sort-key="vehical_id.name">Vehicles</vs-th>
              <vs-th sort-key="vehical_id.number">Registration #</vs-th>
              <vs-th sort-key="from_date">Start/End Date</vs-th>
              <vs-th sort-key="from_time">Start Time</vs-th>
              <vs-th sort-key="to_time">End Time</vs-th>
              <vs-th sort-key="status">Status</vs-th>
              <vs-th>Unbook</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                <vs-td :data="tr.vehical_id.name">{{ tr.vehical_id.name }} {{ tr.vehical_id.brand }}</vs-td>
                <vs-td :data="tr.vehical_id.number">{{ tr.vehical_id ? tr.vehical_id.number: '' }}</vs-td>
                <vs-td :data="tr.from_date+' - '+tr.to_date">
                  <span v-if="tr.from_date == tr.to_date">{{ tr.from_date }}</span>
                  <span v-else>{{ tr.from_date }} - {{ tr.to_date }}</span>
                </vs-td>
                <vs-td :data="tr.from_time">{{ tr.from_time }}</vs-td>
                <vs-td :data="tr.to_time">{{ tr.to_time}}</vs-td>
                <vs-td :data="tr.status | vehicleStatus">
                  {{ tr.status | vehicleStatus}}
                  <span v-if="tr.user_id && tr.user_id.firstname">- {{tr.user_id.firstname | capitalize}} {{ (tr.user_id.lastname ? tr.user_id.lastname.charAt(0) : '') | capitalize}}</span>
                  
                </vs-td>
                <vs-td>
                  <vs-button
                    color="danger"
                    type="filled"
                    size="small"
                    title="Unbook Vehicle"
                    @click.stop="unbook(data[indextr].id)"
                    name="unbook_btn"
                    :disabled="tr.status !== 'BO'"
                  >Unbook</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
</template>

<script>
import { Validator } from "vee-validate";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

Validator.extend("verify_password", {
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

const dict = {
  custom: {
    vehicle_id: {
      max: "Vehicle ID should not be greater than 5 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
    office_id: {
      required: "Please select office"
    },
    name: {
      required: "Please enter name",
      max: "Vehicle make should not be greater than 25 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
    from_date: {
      required: "Please select start date"
    },
    start_time: {
      required: "Please select start time"
    },
    end_date: {
      required: "Please select end date"
    },
    end_time: {
      required: "Please select end time"
    },
    year: {
      required: "Please enter vehicle year",
      max: "Vehicle year should not be greater than 4 digits",
      alpha_num: "Only alphanumeric value is allowed",
      between: "Year must be between 2000-" + new Date().getFullYear()
    },
    type: {
      max: "type name should not be greater than 25 characters",
      alpha_num: "Only alphanumeric value is allowed"
    },
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      vehicle_id: null,
      is_disabled: false,
      receipts: [],
      vehicles: [],
      booked: [],
      currentYear: new Date().getFullYear(),
      offices: [],
      deleteIndex: 0,
      vehicleAddEdit: false,
      vehicleBook: false,
      availableVehicle: [],
      office_id: null,
      vehicleID: null,
      disabledPastDates: {
        to: new Date(Date.now() - 8640000)
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "G:i K"
      },
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,
        dateFormat: "d/m/Y"
      },
      configTodateTimePicker: {
        minDate: new Date(),
        dateFormat: "d/m/Y"
      },
      month: null,
      filter_office_id: "all",
      start_time: null,
      from_date: null,
      end_time: null,
      end_date: null,
      status_arr: [
        {
          value: "AV",
          name: "Available"
        },
        {
          value: "BD",
          name: "Break Down"
        }
      ],
      types: [
        { value: "Sedan", name: "Sedan" },
        { value: "Pickup", name: "Pickup" },
        { value: "Wagon", name: "Wagon" },
        { value: "Ute", name: "Ute" },
        { value: "Van", name: "Van" }
      ] 
    };
  },
  created() {
    // if (
    //   this.$store.state.uInfo.role !== "CA" &&
    //   this.$store.state.uInfo.role !== "HR"
    // ) {
    //   history.back();
    // }
  },
  mounted() {
    this.getOffice(); // get vehicle 
    this.vehiclebooked(); // get all booked vehicle 
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** Check start & end date/time */
    endTimeCheck() {
      let start = moment(this.start_time, ["h:mm A"]).format("HH:mm");
      let end = moment(this.end_time, ["h:mm A"]).format("HH:mm");
      if (end < start) {
        this.$vs.notify({
          text: "End time should exceed the start time",
          position: "top-right",
          color: "danger"
        });
        return false;
      } else if (end == start) {
        this.$vs.notify({
          text: "Start time and end time cannot be same",
          position: "top-right",
          color: "danger"
        });
        return false;
      }
    },
    /** Cancle book form */
    cancelBook() {
      this.vehicleBook = false;
      (this.configFromdateTimePicker.maxDate = null),
        (this.configTodateTimePicker.minDate = null),
       this.office_id = this.$store.state.uInfo.office_id;
      this.from_date = null;
      this.start_time = null;
      this.end_date = null;
      this.end_time = null;
      this.availableVehicle = [];
    },
    /** Book confitmation */
    confirmBook(id) {
      this.vehicleID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to book this vehicle?",
        acceptText: "Book",
        accept: this.bookVehicle
      });
    },
    /** Book vehicle */
    bookVehicle(vehicle_id) {
      this.$vs.loading({ color: "primary" });
      let input = {
        vehical_id: this.vehicleID,
        from_date: this.from_date,
        from_time: this.start_time,
        to_date: this.end_date,
        to_time: this.end_time
      };
      this.axios
        .post("vehicalBooking", input)
        .then(response => {
          this.button_loader(false, "#vehicle-addupdate");
          let text = "Vehicle booked successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.vehicleBook = false;
          (this.configFromdateTimePicker.maxDate = null),
            (this.configTodateTimePicker.minDate = null),
             this.office_id = this.$store.state.uInfo.office_id;
          this.from_date = null;
          this.start_time = null;
          this.end_date = null;
          this.end_time = null;
          this.vehicleID = null;
          this.availableVehicle = [];
          this.$vs.loading.close();
          this.vehiclebooked();
        })
        .catch(e => {
          this.showError(e, "#vehicle-addupdate");
        });
    },
    /** Search vehicle */
    searchVehicle() {
      this.$validator.validateAll("book-form").then(result => {
        if (result) {
          if (this.from_date == this.end_date) {
            if (this.endTimeCheck() == false) {
              return;
            }
          }
          this.$vs.loading({ color: "primary" });
          let input = {
            office_id: this.office_id,
            from_date: this.from_date,
            from_time: this.start_time,
            to_date: this.end_date,
            to_time: this.end_time
          };
          let url = "vehicalBooking";
          this.axios
            .get(url, { params: input })
            .then(response => {
              let data = response.data.data;
              this.$vs.loading.close();
              if (data.length == 0) {
                this.$vs.notify({
                  text: "Vehicles are not available.",
                  color: "danger",
                  position: "top-right"
                });
                return;
              }
              this.availableVehicle = data;
            })
            .catch(e => {
              this.showError(e);
            });
        }
      });
    },
    /** Change form & end date configration */
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
      this.end_date = dateStr;
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    /** Vehicle Booking */
    vehiclebooked() {
      let url = "vehicalBooked";
      if (this.filter_office_id != 'all') {
        url += "?office_id="+this.filter_office_id;
      }
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.booked = data.responseData;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    /** Get all Office */
    getOffice() {
      this.$vs.loading({ color: "primary" });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.offices = data;
          this.$vs.loading.close();
          this.office_id = this.$store.state.uInfo.office_id;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    /** Confirmation Unbook  */
    unbook(index) {
      this.deleteIndex = index;
      this.$vs.dialog({
        type: "confirm",
        buttonvariant:"success",
        title: `Confirm`,
        text: "Are you sure you want to unbook this vehicle?",
        acceptText: "Sure",
        accept: this.unBookVehicle
      });
    },
    /** Unbook vehicle */
    unBookVehicle() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("vehicalBooking", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Vehicle unbooked successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.vehiclebooked();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
  }
};
</script>
<style>
.code-border {
  border: 1px solid;
}

.selectAll .input-select-con {
  margin-bottom: 15px;
}
.size {
  height: 25px;
}
.rsize {
  height: 50px;
  width: 60px;
}
.vehicle-type .vx-col {
  padding: 0 0rem;
}
.radio {
  width: auto !important;
}
.pad0 {
  padding: 0 !important;
}
.padr0 {
  padding-right: 0 !important;
}
.r_align {
  align-items: baseline !important;
}
</style>

		